import _ from "lodash"
import {translateName} from "../../../../utils/i18n"

export const entity = {
    name: "AuditTheme",
    facets: ["codeName"],
    fields: [
        {path: "active", type: "boolean", default: true},
        {
            path: "translatedFullName",
            $f: function(object, context, callback) {
                const language = _.get(context, "language.id")
                return callback(null, `${object.code} : ${translateName(object.name, language)}`)
            }
        }
    ],
    filters: [
        {
            name: "activeThemes",
            isDefault: false,
            query: () => ({active: true})
        },
        {
            name: "themesWithActiveControls",
            isDefault: false,
            async: true,
            query: async function(context, callback) {
                try {
                    const controls = await global.app.S.AuditControl.find({
                        query: {active: true},
                        group: context.group,
                        fieldPath: ['auditTheme.id']
                    })
                    const themeIds = [...new Set(
                        controls.map(c => c.auditTheme?.id).filter(Boolean)
                    )].map(id => new global.ObjectID(id))
                    if (!themeIds.length) return callback(null, {_id: null})
                    return callback(null, {_id: {$in: themeIds}})
                } catch(e) {
                    return callback(null, {_id: null})
                }
            }
        },
        {
            name: "byActiveStatus",
            path: 'activeStatus',
            object: 'ActiveStatus',
            display: "name",
            translate: true,
            client: true,
            default: { id: 'active', name: 'active' },
            isDefault: false,
            query: function(context) {
                const status = _.get(context, 'data.activeStatus')
                return !!status?.id ?
                    status?.id === 'inactive' ? {active: false} : {active: true}
                    : {}
            }
        }
    ]
}

export const module_ = {
    object: "AuditTheme",
    tKey: "mTitle_auditTheme",
    filters: ["byActiveStatus"],
    category: {
        path: "audit",
        icon: "clipboardCheck"
    },
    defaultSortBy: "code",
    defaultSortDirection: "ASC",
    viewMap: {
        dt: [
            "code",
            {path: "name", translateName: true}
        ],
        form: [
            {path: "code", required: true},
            {path: "name", type: "textarea", required: true},
            {path: "active", type: "booleanToggle", default: true}
        ]
    }
}